import React from "react";
import { MapPin } from "lucide-react";

/**
 * Price — Route points (départ + arrivée).
 *
 * Affiche 2 lignes verticales : à gauche l'icône correspondante (rouge
 * pour le départ, jaune pour l'arrivée), à droite l'adresse. Chaque
 * adresse est ALIGNÉE avec sa propre icône, quelle que soit la longueur
 * du texte — c'est le point critique par rapport à un layout où les
 * icônes vivent dans une colonne séparée à hauteur fixe.
 */
export default function RoutePoints({
  from,
  to,
  size = "md",           // "sm" (dashboards compacts) | "md" (par défaut)
  truncate = false,
  fromLabel,             // Optional "Départ"/"Arrivée" caption above the address
  toLabel,
  className = "",
}) {
  const dot = size === "sm" ? "h-7 w-7" : "h-8 w-8";
  const icon = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";
  const line = size === "sm" ? "ml-3 h-3" : "ml-3.5 h-3";
  const text = size === "sm" ? "text-[13px]" : "text-[15px]";
  const wrap = truncate ? "truncate" : "";
  const captionCls = "text-[10px] font-black uppercase tracking-widest text-foreground/50 leading-none";
  return (
    <div className={`min-w-0 space-y-2 ${className}`}>
      <div className="flex items-start gap-3">
        <div className={`grid ${dot} flex-none place-items-center rounded-full bg-primary text-primary-foreground street-border-thin`}>
          <MapPin className={icon} strokeWidth={2.5} />
        </div>
        <div className="min-w-0 flex-1 pt-0.5">
          {fromLabel && <div className={captionCls}>{fromLabel}</div>}
          <div className={`font-[Outfit] ${text} font-black leading-tight ${wrap}`}>{from}</div>
        </div>
      </div>
      <div className={`${line} w-1 rounded-full bg-foreground/15`} />
      <div className="flex items-start gap-3">
        <div className={`grid ${dot} flex-none place-items-center rounded-full bg-accent text-accent-foreground street-border-thin`}>
          <MapPin className={icon} strokeWidth={2.5} />
        </div>
        <div className="min-w-0 flex-1 pt-0.5">
          {toLabel && <div className={captionCls}>{toLabel}</div>}
          <div className={`font-[Outfit] ${text} font-black leading-tight ${wrap}`}>{to}</div>
        </div>
      </div>
    </div>
  );
}
